import React from "react";
import { TemplatePaiementValide } from './../../Templates/index';

const PaiementValide = () => {

  const TYPE_PAIEMENT_IMP_PRELEVEMENT = 'I';
  const URL_REDIRECTION_ENVOYER_DOC_BANQUE_SEPA = '/documents/send?category=BANQUE&subCategory=SEPA%20-%20mes%20cotisations';
  const codeMethodePaiement = localStorage.getItem('codeMethodePaiement');

  return (
    <TemplatePaiementValide
      // Existe t-il un paiement par prélèvement
      hasPrelevement = {codeMethodePaiement?.toUpperCase() === TYPE_PAIEMENT_IMP_PRELEVEMENT}
      url = {URL_REDIRECTION_ENVOYER_DOC_BANQUE_SEPA}
    />    
  );
};

export default React.memo(PaiementValide);
